var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "div",
        {
          staticClass: "wrapper",
          attrs: { id: "sideBarModalComponent" },
          on: { click: _vm.onClose },
        },
        [
          _c("div", { class: { wrapper_body: true, open: _vm.open } }, [
            _vm.loading
              ? _c(
                  "div",
                  { staticClass: "loading_div" },
                  [
                    _c("pulse-loader", {
                      staticClass: "text-center",
                      attrs: { loading: _vm.loading, color: _vm.color },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.loading && _vm.userWebSettings
              ? _c("div", { staticClass: "modal_body" }, [
                  _c("div", [
                    _c("div", { staticClass: "from-group row" }, [
                      _c(
                        "label",
                        { staticClass: "col-sm-4", attrs: { for: "" } },
                        [_vm._v("Имя")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-8" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.$currentUser.name,
                              expression: "$currentUser.name",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", disabled: "" },
                          domProps: { value: _vm.$currentUser.name },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.$currentUser,
                                "name",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("div", { staticClass: "form-check" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.userWebSettings.incomeCalls,
                              expression: "userWebSettings.incomeCalls",
                            },
                          ],
                          attrs: { type: "checkbox", id: "ch_1" },
                          domProps: {
                            checked: Array.isArray(
                              _vm.userWebSettings.incomeCalls
                            )
                              ? _vm._i(_vm.userWebSettings.incomeCalls, null) >
                                -1
                              : _vm.userWebSettings.incomeCalls,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.userWebSettings.incomeCalls,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.userWebSettings,
                                      "incomeCalls",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.userWebSettings,
                                      "incomeCalls",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(
                                  _vm.userWebSettings,
                                  "incomeCalls",
                                  $$c
                                )
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          { staticClass: "pointer", attrs: { for: "ch_1" } },
                          [_vm._v("Показывать окно с входящими звонками")]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-check" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.userWebSettings.newOrder,
                              expression: "userWebSettings.newOrder",
                            },
                          ],
                          attrs: { type: "checkbox", id: "ch_2" },
                          domProps: {
                            checked: Array.isArray(_vm.userWebSettings.newOrder)
                              ? _vm._i(_vm.userWebSettings.newOrder, null) > -1
                              : _vm.userWebSettings.newOrder,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.userWebSettings.newOrder,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.userWebSettings,
                                      "newOrder",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.userWebSettings,
                                      "newOrder",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.userWebSettings, "newOrder", $$c)
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          { staticClass: "pointer", attrs: { for: "ch_2" } },
                          [_vm._v("Показывать уведомление о новых заявках")]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-check" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.userWebSettings.notificationSound,
                              expression: "userWebSettings.notificationSound",
                            },
                          ],
                          attrs: { type: "checkbox", id: "ch_3" },
                          domProps: {
                            checked: Array.isArray(
                              _vm.userWebSettings.notificationSound
                            )
                              ? _vm._i(
                                  _vm.userWebSettings.notificationSound,
                                  null
                                ) > -1
                              : _vm.userWebSettings.notificationSound,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.userWebSettings.notificationSound,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.userWebSettings,
                                      "notificationSound",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.userWebSettings,
                                      "notificationSound",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(
                                  _vm.userWebSettings,
                                  "notificationSound",
                                  $$c
                                )
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          { staticClass: "pointer", attrs: { for: "ch_3" } },
                          [_vm._v("Использовать звук для уведомлений")]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.manageChatMessages
                        ? [
                            _c("div", { staticClass: "form-check" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.userWebSettings.showChatMessages,
                                    expression:
                                      "userWebSettings.showChatMessages",
                                  },
                                ],
                                attrs: { type: "checkbox", id: "ch_4" },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.userWebSettings.showChatMessages
                                  )
                                    ? _vm._i(
                                        _vm.userWebSettings.showChatMessages,
                                        null
                                      ) > -1
                                    : _vm.userWebSettings.showChatMessages,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a =
                                        _vm.userWebSettings.showChatMessages,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.userWebSettings,
                                            "showChatMessages",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.userWebSettings,
                                            "showChatMessages",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.userWebSettings,
                                        "showChatMessages",
                                        $$c
                                      )
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "pointer",
                                  attrs: { for: "ch_4" },
                                },
                                [_vm._v("Показывать сообщения с чатов")]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-check" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.userWebSettings.soundChatMessages,
                                    expression:
                                      "userWebSettings.soundChatMessages",
                                  },
                                ],
                                attrs: {
                                  type: "checkbox",
                                  disabled:
                                    !_vm.userWebSettings.showChatMessages,
                                  id: "ch_5",
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.userWebSettings.soundChatMessages
                                  )
                                    ? _vm._i(
                                        _vm.userWebSettings.soundChatMessages,
                                        null
                                      ) > -1
                                    : _vm.userWebSettings.soundChatMessages,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a =
                                        _vm.userWebSettings.soundChatMessages,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.userWebSettings,
                                            "soundChatMessages",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.userWebSettings,
                                            "soundChatMessages",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.userWebSettings,
                                        "soundChatMessages",
                                        $$c
                                      )
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "pointer",
                                  attrs: { for: "ch_5" },
                                },
                                [
                                  _vm._v(
                                    "Использовать звук для сообщений с чата"
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "text-right" },
                    [
                      _c("LoadingButton", {
                        attrs: {
                          title: "Сохранить",
                          className: "btn btn-success",
                          loading: _vm.btnLoading,
                          onClick: _vm.updateSettings,
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }